import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "comment-list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CommentListItem = _resolveComponent("CommentListItem")!
  const _component_ElPagination = _resolveComponent("ElPagination")!
  const _component_CreateComment = _resolveComponent("CreateComment")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (comment) => {
      return (_openBlock(), _createBlock(_component_CommentListItem, {
        key: comment._id,
        comment: comment,
        targetType: _ctx.targetType
      }, null, 8, ["comment", "targetType"]))
    }), 128)),
    (_ctx.paginationVersions.total > 20)
      ? (_openBlock(), _createBlock(_component_ElPagination, {
          key: 0,
          layout: "prev, pager, next",
          total: _ctx.paginationVersions.total,
          "pager-count": 20,
          size: "small",
          onCurrentChange: _ctx.handlePageChangeRank
        }, null, 8, ["total", "onCurrentChange"]))
      : _createCommentVNode("", true),
    (_ctx.targetType != 'ALL')
      ? (_openBlock(), _createBlock(_component_CreateComment, {
          key: 1,
          "target-type": _ctx.targetType,
          "target-id": _ctx.targetId,
          "comment-info": _ctx.commentInfo,
          onChange: _ctx.pushNewComment
        }, null, 8, ["target-type", "target-id", "comment-info", "onChange"]))
      : _createCommentVNode("", true)
  ])), [
    [_directive_loading, _ctx.loadings.main]
  ])
}